<div class="row mb-3 mt-2">
    <div class="col-1" style="text-align: left">
        <label for="stage" class="form-label"># of Stages</label>
    </div>
    <div class="col-4">
        <select class="form-select border border-dark" [(ngModel)]="selectedStage" name="stage" >
            <option *ngFor="let stages of stage" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        
    </div>
    <div class="col-1" style="text-align: left">
        <label for="stage" class="form-label">Warranty Condition</label>
    </div>
    <div class="col-4">
        <!-- <select class="form-select border border-dark" [(ngModel)]="warrantyId" id="warrantyCondition"
            name="warrantyCondition">
            <option [ngValue]="undefined" selected disabled>Select Warranty Condition</option>
            <option *ngFor="let stages of warrantyList" [value]="stages.Id" [selected]="stages.Id === warrantyId">
                {{ stages.Name }}
            </option>
        </select> -->
           <select class="form-select border border-dark" [(ngModel)]="warrantyId" 
                id="warrantyCondition" name="warrantyCondition">
            <option value="0">Select Warranty Condition</option> 
            <option *ngFor="let warranty of warrantyList" [value]="warranty.Id">
                {{ warranty.Name }}
            </option>
        </select>
    </div>
    <div class="col-2">
        <button type="button" class="btn custom-buttons-btn" (click)="showGraph()">
            Generate Graph
        </button>
    </div>
</div>

<div class="row mb-3 mt-2">
   

</div>


<div class="row" style="text-align: center;">
    <h4 [innerHtml]="graphName"></h4>
    <div id="plot" style="border:deepskyblue;" style="height: 600px; width: NewWidth;">
    </div> 
</div>